import { render } from "./Receipt_Details.vue?vue&type=template&id=7dff84ee"
import script from "./Receipt_Details.vue?vue&type=script&lang=js"
export * from "./Receipt_Details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__